export const DEFAULT_POSITION = [
	0.597584068775177,
	0.5122368931770325,
	-0.028051288798451424,
	0.5967282652854919,
	0.5585823059082031,
	-0.06827813386917114,
	0.595363199710846,
	0.5465003252029419,
	-0.031898822635412216,
	0.6041821241378784,
	0.6086804866790771,
	-0.05589400976896286,
	0.5962452292442322,
	0.573085606098175,
	-0.07450614124536514,
	0.5946764349937439,
	0.5931726098060608,
	-0.07159314304590225,
	0.5899791717529297,
	0.6430703401565552,
	-0.04436807334423065,
	0.67838454246521,
	0.6593220233917236,
	0.016294442117214203,
	0.5877543091773987,
	0.6745568513870239,
	-0.0413186177611351,
	0.5869603753089905,
	0.6935017108917236,
	-0.04745618626475334,
	0.5816501379013062,
	0.779848039150238,
	-0.042868249118328094,
	0.5978976488113403,
	0.5054249167442322,
	-0.025547420606017113,
	0.5978557467460632,
	0.5013006925582886,
	-0.02036227099597454,
	0.5973365902900696,
	0.5003284215927124,
	-0.014039026573300362,
	0.5970479846000671,
	0.49754413962364197,
	-0.011204810813069344,
	0.5973528623580933,
	0.4921146035194397,
	-0.012626622803509235,
	0.5977947115898132,
	0.4853774905204773,
	-0.014603002928197384,
	0.597919225692749,
	0.47811874747276306,
	-0.012000382877886295,
	0.597602367401123,
	0.46524766087532043,
	0.001983312424272299,
	0.5964838266372681,
	0.5520298480987549,
	-0.06071425974369049,
	0.6072486042976379,
	0.5549895167350769,
	-0.04127464070916176,
	0.7217085957527161,
	0.7237116098403931,
	0.07248257845640182,
	0.6416465640068054,
	0.6432689428329468,
	0.0018072782550007105,
	0.6546133160591125,
	0.6430615782737732,
	0.0035426770336925983,
	0.6671338677406311,
	0.6445352435112,
	0.00773812597617507,
	0.6832059621810913,
	0.6544572710990906,
	0.019097862765192986,
	0.6311497688293457,
	0.6458761692047119,
	0.0012961032334715128,
	0.6586965322494507,
	0.6754084229469299,
	-0.006046702153980732,
	0.6450702548027039,
	0.6740657091140747,
	-0.007615192793309689,
	0.6709392070770264,
	0.6746220588684082,
	-0.000881765503436327,
	0.6791203022003174,
	0.6716819405555725,
	0.005486492067575455,
	0.6946684122085571,
	0.6456027030944824,
	0.02723051980137825,
	0.6447452306747437,
	0.44643864035606384,
	0.02417730540037155,
	0.6829148530960083,
	0.6629987955093384,
	0.02015218324959278,
	0.7309252023696899,
	0.6593643426895142,
	0.088451087474823,
	0.7088413834571838,
	0.6560789346694946,
	0.03979205712676048,
	0.6565970778465271,
	0.5812364220619202,
	-0.002463678363710642,
	0.6127680540084839,
	0.5154179334640503,
	-0.025404665619134903,
	0.6107486486434937,
	0.5024060010910034,
	-0.01744835264980793,
	0.6279534101486206,
	0.513091504573822,
	-0.016086377203464508,
	0.6377556324005127,
	0.5092297792434692,
	-0.0050071789883077145,
	0.6215190291404724,
	0.5028899908065796,
	-0.011300934478640556,
	0.6301767230033875,
	0.5032271146774292,
	-0.0014937336090952158,
	0.6532092094421387,
	0.49195513129234314,
	0.019588898867368698,
	0.6071991920471191,
	0.559777557849884,
	-0.06653857231140137,
	0.6086122393608093,
	0.5737631916999817,
	-0.07219526916742325,
	0.6991390585899353,
	0.6851577162742615,
	0.0062843207269907,
	0.6286460757255554,
	0.6165348887443542,
	-0.011625250801444054,
	0.6346508264541626,
	0.5690491199493408,
	-0.03137127682566643,
	0.6347075700759888,
	0.5773864984512329,
	-0.027967827394604683,
	0.6945300102233887,
	0.5864663124084473,
	0.016185779124498367,
	0.6063978672027588,
	0.5924419164657593,
	-0.06629480421543121,
	0.6682231426239014,
	0.6933223009109497,
	-0.02194802835583687,
	0.6863858699798584,
	0.6918083429336548,
	-0.009778991341590881,
	0.7091013789176941,
	0.7469769716262817,
	0.041038259863853455,
	0.6132028102874756,
	0.6779560446739197,
	-0.035334259271621704,
	0.6331472396850586,
	0.670049786567688,
	-0.0037244763225317,
	0.6630505919456482,
	0.5049932599067688,
	0.022168323397636414,
	0.7215963006019592,
	0.5240747332572937,
	0.1439662128686905,
	0.6254160404205322,
	0.5605108737945557,
	-0.025925854220986366,
	0.6150547862052917,
	0.5550880432128906,
	-0.02817643992602825,
	0.6485419273376465,
	0.5037428736686707,
	0.019547492265701294,
	0.6427199244499207,
	0.504209041595459,
	0.015221400186419487,
	0.6931158304214478,
	0.7028365731239319,
	-0.004058110527694225,
	0.634718656539917,
	0.5636073350906372,
	-0.023171067237854004,
	0.6441227197647095,
	0.6896411180496216,
	-0.03067934513092041,
	0.6464415192604065,
	0.7024542689323425,
	-0.03501669317483902,
	0.65793776512146,
	0.775926411151886,
	-0.018611056730151176,
	0.7007876634597778,
	0.7261034250259399,
	0.014999687671661377,
	0.6509052515029907,
	0.7411677241325378,
	-0.028157919645309448,
	0.7067745327949524,
	0.6938604116439819,
	0.017360538244247437,
	0.714536190032959,
	0.7084218859672546,
	0.043008968234062195,
	0.612159252166748,
	0.5072938203811646,
	-0.02286752313375473,
	0.6244387030601501,
	0.5065721273422241,
	-0.014235980808734894,
	0.6339299082756042,
	0.505737841129303,
	-0.004287747200578451,
	0.6221928000450134,
	0.5578425526618958,
	-0.02382677234709263,
	0.6454678177833557,
	0.5037370920181274,
	0.017182888463139534,
	0.6400778293609619,
	0.500971257686615,
	0.008961204439401627,
	0.6412352919578552,
	0.5049329400062561,
	0.014591737650334835,
	0.6196542382240295,
	0.5631129741668701,
	-0.04575018957257271,
	0.6273888349533081,
	0.5042110085487366,
	0.0007319872383959591,
	0.6187172532081604,
	0.5031090378761292,
	-0.00584834860637784,
	0.6086117625236511,
	0.5015190243721008,
	-0.011396178044378757,
	0.613655149936676,
	0.4667019844055176,
	0.0034802076406776905,
	0.6125679016113281,
	0.4800979495048523,
	-0.010194817557930946,
	0.6117227077484131,
	0.4876881241798401,
	-0.012622324749827385,
	0.610632061958313,
	0.49440231919288635,
	-0.010316146537661552,
	0.6092167496681213,
	0.49879127740859985,
	-0.008737782016396523,
	0.6289371252059937,
	0.5021269917488098,
	0.0022035834845155478,
	0.630825400352478,
	0.5005471110343933,
	0.0003899023577105254,
	0.6336177587509155,
	0.4973981976509094,
	-0.0005309130647219718,
	0.6361297369003296,
	0.4931390583515167,
	0.0024349421728402376,
	0.6486418843269348,
	0.5269691348075867,
	-0.0022767367772758007,
	0.7312617301940918,
	0.5982346534729004,
	0.15416981279850006,
	0.5958456993103027,
	0.5501752495765686,
	-0.04222862794995308,
	0.6345977187156677,
	0.503113329410553,
	0.00927984993904829,
	0.6370877027511597,
	0.502642035484314,
	0.008397147059440613,
	0.6111913323402405,
	0.5482578277587891,
	-0.027388937771320343,
	0.6303856372833252,
	0.5550988912582397,
	-0.01301523670554161,
	0.6131489872932434,
	0.5514347553253174,
	-0.028308415785431862,
	0.6418907046318054,
	0.6096106171607971,
	-0.004673521965742111,
	0.6634712815284729,
	0.6010817289352417,
	0.0013577090576291084,
	0.6365949511528015,
	0.5718649625778198,
	-0.019444353878498077,
	0.6888689994812012,
	0.7648157477378845,
	0.009132291190326214,
	0.6802739500999451,
	0.7375373244285583,
	-0.007788379210978746,
	0.6723787784576416,
	0.7065309882164001,
	-0.020596865564584732,
	0.6428448557853699,
	0.48242488503456116,
	0.013434926979243755,
	0.6172218322753906,
	0.6972134709358215,
	-0.043508078902959824,
	0.620203971862793,
	0.7410112619400024,
	-0.040685828775167465,
	0.6236055493354797,
	0.7805084586143494,
	-0.036001887172460556,
	0.6775220036506653,
	0.6482770442962646,
	0.013777976855635643,
	0.7096003890037537,
	0.6361182928085327,
	0.03694845736026764,
	0.6245864033699036,
	0.6487201452255249,
	0.0023408399429172277,
	0.6937344670295715,
	0.6699916124343872,
	0.017328178510069847,
	0.619555652141571,
	0.6246581077575684,
	-0.018410902470350266,
	0.6276017427444458,
	0.5722575783729553,
	-0.04580232873558998,
	0.7234979271888733,
	0.6281430721282959,
	0.054451946169137955,
	0.7013242840766907,
	0.6243062019348145,
	0.026095718145370483,
	0.6847876310348511,
	0.6169044971466064,
	0.013293273746967316,
	0.6595296859741211,
	0.617617130279541,
	0.004958524368703365,
	0.6412346959114075,
	0.6225915551185608,
	0.00026692773099057376,
	0.6280146241188049,
	0.628188967704773,
	-0.005619999021291733,
	0.6025046110153198,
	0.6403722167015076,
	-0.03756927326321602,
	0.723274827003479,
	0.5964245796203613,
	0.054969802498817444,
	0.7047872543334961,
	0.6727436780929565,
	0.023484043776988983,
	0.602785050868988,
	0.5530483722686768,
	-0.059398893266916275,
	0.6287304759025574,
	0.6011059284210205,
	-0.014482149854302406,
	0.7315966486930847,
	0.6642927527427673,
	0.13364621996879578,
	0.6182049512863159,
	0.6345085501670837,
	-0.009625561535358429,
	0.6371392607688904,
	0.5718885660171509,
	-0.005795842036604881,
	0.68679279088974,
	0.6620866060256958,
	0.02291913703083992,
	0.6272032260894775,
	0.5824096202850342,
	-0.04187924042344093,
	0.7288002967834473,
	0.5621649026870728,
	0.15262971818447113,
	0.6245347261428833,
	0.6542900800704956,
	0.005082952324301004,
	0.6172586679458618,
	0.5888647437095642,
	-0.05669143795967102,
	0.698346734046936,
	0.4834224283695221,
	0.07442153245210648,
	0.696480393409729,
	0.46957191824913025,
	0.10064975917339325,
	0.7339246869087219,
	0.5966627597808838,
	0.10488706827163696,
	0.7136958241462708,
	0.5044869780540466,
	0.08993417769670486,
	0.7230542898178101,
	0.686802864074707,
	0.06924804300069809,
	0.6476432681083679,
	0.4331321716308594,
	0.034571852535009384,
	0.6008877754211426,
	0.5511133670806885,
	-0.04098920524120331,
	0.6402345299720764,
	0.5918145179748535,
	-0.00732794962823391,
	0.7199708223342896,
	0.6551348567008972,
	0.05448891222476959,
	0.6656532883644104,
	0.6534794569015503,
	0.008269526064395905,
	0.6543117761611938,
	0.6513825058937073,
	0.004339221399277449,
	0.6432578563690186,
	0.4987879991531372,
	0.01176439132541418,
	0.7219845652580261,
	0.5669344663619995,
	0.06350813806056976,
	0.6248161792755127,
	0.413350373506546,
	0.03935292363166809,
	0.6613103151321411,
	0.43515676259994507,
	0.06608260422945023,
	0.6775713562965393,
	0.4492267370223999,
	0.0812063068151474,
	0.5844548940658569,
	0.738898515701294,
	-0.04618336632847786,
	0.5988568663597107,
	0.4088538885116577,
	0.033782027661800385,
	0.6435248851776123,
	0.6514523029327393,
	0.002659075427800417,
	0.6334372162818909,
	0.652926504611969,
	0.003352593397721648,
	0.6272942423820496,
	0.653552770614624,
	0.0052078706212341785,
	0.7140105366706848,
	0.6777069568634033,
	0.037286482751369476,
	0.6350667476654053,
	0.6650949716567993,
	0.00025843404000625014,
	0.6459973454475403,
	0.6697635650634766,
	-0.0017647934146225452,
	0.6575464010238647,
	0.6713786125183105,
	-0.00027374393539503217,
	0.668944776058197,
	0.669925332069397,
	0.0039377943612635136,
	0.6759095191955566,
	0.6669122576713562,
	0.009080639109015465,
	0.7287253737449646,
	0.6979261040687561,
	0.10571884363889694,
	0.6731349229812622,
	0.6563650965690613,
	0.01263690460473299,
	0.5959664583206177,
	0.5358293056488037,
	-0.027530809864401817,
	0.6371495723724365,
	0.5343661904335022,
	-0.011242687702178955,
	0.6258845329284668,
	0.5621902942657471,
	-0.03194599598646164,
	0.6132814884185791,
	0.535895049571991,
	-0.025143468752503395,
	0.5883598923683167,
	0.6603836417198181,
	-0.03740541636943817,
	0.6810069680213928,
	0.46356669068336487,
	0.06206328049302101,
	0.6649413108825684,
	0.4483012557029724,
	0.049313735216856,
	0.6261347532272339,
	0.42170408368110657,
	0.02103644795715809,
	0.7104422450065613,
	0.49282026290893555,
	0.12410101294517517,
	0.6278473138809204,
	0.6584839224815369,
	0.0028743918519467115,
	0.6124112010002136,
	0.6176889538764954,
	-0.03677929937839508,
	0.5993651151657104,
	0.41759443283081055,
	0.01607094518840313,
	0.6445260643959045,
	0.42281869053840637,
	0.05040973052382469,
	0.7313166260719299,
	0.5639280676841736,
	0.10714519768953323,
	0.620040237903595,
	0.5004158020019531,
	-0.003688700729981065,
	0.6219918727874756,
	0.4974656403064728,
	-0.005657417234033346,
	0.6238498091697693,
	0.49259135127067566,
	-0.006874070968478918,
	0.625573456287384,
	0.48571640253067017,
	-0.00424779811874032,
	0.6298570036888123,
	0.4738302230834961,
	0.006881120149046183,
	0.6378323435783386,
	0.5036218166351318,
	0.0070981779135763645,
	0.6415999531745911,
	0.5046277642250061,
	0.007165220566093922,
	0.6451493501663208,
	0.5067276358604431,
	0.00727017130702734,
	0.6582596302032471,
	0.516936182975769,
	0.00953766144812107,
	0.7060785293579102,
	0.5563026666641235,
	0.035442110151052475,
	0.6107326149940491,
	0.6334069967269897,
	-0.027013909071683884,
	0.6143887042999268,
	0.6611696481704712,
	-0.007210137322545052,
	0.622404158115387,
	0.6606694459915161,
	-0.0009888665517792106,
	0.6348552107810974,
	0.5053471922874451,
	0.008530537597835064,
	0.7080464363098145,
	0.5226761102676392,
	0.06089344993233681,
	0.6043440699577332,
	0.6595162749290466,
	-0.025976156815886497,
	0.6379470229148865,
	0.4600217342376709,
	0.016347840428352356,
	0.5930439829826355,
	0.6101597547531128,
	-0.061806123703718185,
	0.603573739528656,
	0.6238319277763367,
	-0.04834100604057312,
	0.5915900468826294,
	0.6260727643966675,
	-0.052646420896053314,
	0.6223673224449158,
	0.595625638961792,
	-0.03220928832888603,
	0.5991707444190979,
	0.431388258934021,
	0.006417833734303713,
	0.5982794761657715,
	0.44950008392333984,
	0.00455165421590209,
	0.6188966035842896,
	0.45139080286026,
	0.008398615755140781,
	0.6663227677345276,
	0.48698094487190247,
	0.029008174315094948,
	0.6482332348823547,
	0.5613072514533997,
	-0.0009958110749721527,
	0.653148889541626,
	0.4718482494354248,
	0.023432696238160133,
	0.6779701709747314,
	0.5654428005218506,
	0.006166939623653889,
	0.6609395742416382,
	0.5473595857620239,
	0.0038162865675985813,
	0.6895847320556641,
	0.5431552529335022,
	0.021125176921486855,
	0.6239569783210754,
	0.4347035586833954,
	0.01167227141559124,
	0.6295208930969238,
	0.5891523957252502,
	-0.020675651729106903,
	0.6770794987678528,
	0.4779151380062103,
	0.044114693999290466,
	0.6610342860221863,
	0.4612909257411957,
	0.036272019147872925,
	0.6765124201774597,
	0.504513144493103,
	0.029229845851659775,
	0.7192245125770569,
	0.5419985055923462,
	0.0715026780962944,
	0.6924633383750916,
	0.504946231842041,
	0.04378980025649071,
	0.7257359623908997,
	0.5334193110466003,
	0.1051427498459816,
	0.67176753282547,
	0.5290332436561584,
	0.013140039518475533,
	0.6204445362091064,
	0.6098079085350037,
	-0.024873334914445877,
	0.6237228512763977,
	0.5654788017272949,
	-0.04860622435808182,
	0.6311215162277222,
	0.5638071894645691,
	-0.032849524170160294,
	0.6186907291412354,
	0.5734990835189819,
	-0.05987062305212021,
	0.6236940622329712,
	0.6712234020233154,
	-0.012376398779451847,
	0.6441580057144165,
	0.6785266399383545,
	-0.015088687650859356,
	0.6621633768081665,
	0.6811156272888184,
	-0.013046788983047009,
	0.6772578358650208,
	0.6811863780021667,
	-0.006020528730005026,
	0.6878572702407837,
	0.677674412727356,
	0.003719285363331437,
	0.6963497400283813,
	0.6589553356170654,
	0.028900891542434692,
	0.7341514229774475,
	0.628466784954071,
	0.0977800190448761,
	0.6877315044403076,
	0.6383393406867981,
	0.021072475239634514,
	0.6747503280639648,
	0.632607638835907,
	0.01224662084132433,
	0.6573258638381958,
	0.6314256191253662,
	0.005778477061539888,
	0.6409778594970703,
	0.6337921023368835,
	0.002457024296745658,
	0.6287280917167664,
	0.6374652981758118,
	-0.0004955197800882161,
	0.6203356385231018,
	0.6411440968513489,
	-0.002290617674589157,
	0.7312328815460205,
	0.6316544413566589,
	0.14840449392795563,
	0.6304548978805542,
	0.5608689188957214,
	-0.025829749181866646,
	0.6139348149299622,
	0.6035944819450378,
	-0.0447254404425621,
	0.6154800653457642,
	0.5630443096160889,
	-0.05955607816576958,
	0.6083341240882874,
	0.5564923882484436,
	-0.05386507511138916,
	0.6150166392326355,
	0.5615125894546509,
	-0.05278380960226059,
	0.6267946362495422,
	0.556524395942688,
	-0.02112100087106228,
	0.6064229011535645,
	0.554591953754425,
	-0.05736074596643448,
	0.6046380996704102,
	0.5525090098381042,
	-0.04112562537193298,
	0.6203725337982178,
	0.6523374319076538,
	0.002642096485942602,
	0.6134874820709229,
	0.6479132175445557,
	-0.00598163390532136,
	0.6104190945625305,
	0.644288957118988,
	-0.015872271731495857,
	0.6799477338790894,
	0.6647332310676575,
	0.013891543261706829,
	0.6858112812042236,
	0.66835618019104,
	0.014165334403514862,
	0.5818506479263306,
	0.6075195670127869,
	-0.057939887046813965,
	0.49214431643486023,
	0.65007084608078,
	0.0013647516025230289,
	0.5835508704185486,
	0.5535887479782104,
	-0.04281783849000931,
	0.4300937354564667,
	0.7102481126785278,
	0.049473367631435394,
	0.5321562886238098,
	0.6378902792930603,
	-0.007908685132861137,
	0.5187457203865051,
	0.636262059211731,
	-0.008012226782739162,
	0.5054516196250916,
	0.6363983750343323,
	-0.005750928074121475,
	0.4869355261325836,
	0.644393801689148,
	0.003300843993201852,
	0.5429807901382446,
	0.6416113972663879,
	-0.006265479605644941,
	0.5116382241249084,
	0.6688380241394043,
	-0.01829550415277481,
	0.5259827375411987,
	0.6688980460166931,
	-0.01719263382256031,
	0.49888715147972107,
	0.6666198372840881,
	-0.014956877566874027,
	0.49017003178596497,
	0.6626636981964111,
	-0.009829703718423843,
	0.4750588834285736,
	0.6342905759811401,
	0.01011670846492052,
	0.5496111512184143,
	0.4397387206554413,
	0.017523333430290222,
	0.48672279715538025,
	0.6534544229507446,
	0.004513532388955355,
	0.42744332551956177,
	0.6438665390014648,
	0.06474500894546509,
	0.45722436904907227,
	0.6433544754981995,
	0.02047058567404747,
	0.5255895256996155,
	0.573995053768158,
	-0.011942178942263126,
	0.5817243456840515,
	0.5137086510658264,
	-0.027815399691462517,
	0.5842267274856567,
	0.5011433362960815,
	-0.0194685198366642,
	0.5653993487358093,
	0.5093858242034912,
	-0.020889965817332268,
	0.5546598434448242,
	0.5044609308242798,
	-0.011751028709113598,
	0.5721275210380554,
	0.5002256035804749,
	-0.015554376877844334,
	0.5623477697372437,
	0.49918776750564575,
	-0.007049774285405874,
	0.537401556968689,
	0.48475104570388794,
	0.01100845169275999,
	0.5858254432678223,
	0.5586721897125244,
	-0.06784812361001968,
	0.5836111307144165,
	0.5724018216133118,
	-0.07373113185167313,
	0.46679335832595825,
	0.674442708492279,
	-0.011749539524316788,
	0.550311803817749,
	0.6124117970466614,
	-0.017966121435165405,
	0.5530810952186584,
	0.5642958879470825,
	-0.037261202931404114,
	0.5514327883720398,
	0.5725245475769043,
	-0.03411242365837097,
	0.48346590995788574,
	0.5747482776641846,
	0.00037908367812633514,
	0.582703173160553,
	0.5912188291549683,
	-0.06830978393554688,
	0.5012876391410828,
	0.6864969730377197,
	-0.03427444398403168,
	0.4812491536140442,
	0.6827899217605591,
	-0.025466322898864746,
	0.4445561170578003,
	0.7353243827819824,
	0.020364759489893913,
	0.5611920356750488,
	0.6758191585540771,
	-0.03937689587473869,
	0.538538932800293,
	0.6658725738525391,
	-0.011571191251277924,
	0.5264328718185425,
	0.4968096911907196,
	0.011668764054775238,
	0.4463108777999878,
	0.5072990655899048,
	0.12277233600616455,
	0.5629951357841492,
	0.5568661093711853,
	-0.03021933138370514,
	0.5742037296295166,
	0.5526848435401917,
	-0.0302346833050251,
	0.5419890880584717,
	0.49731165170669556,
	0.010570643469691277,
	0.5473287105560303,
	0.49864470958709717,
	0.007382293231785297,
	0.4721071720123291,
	0.6932225227355957,
	-0.020623216405510902,
	0.5524250864982605,
	0.5589223504066467,
	-0.028958186507225037,
	0.5279378294944763,
	0.6849754452705383,
	-0.039109185338020325,
	0.5244609117507935,
	0.6976950764656067,
	-0.04375867173075676,
	0.5020346641540527,
	0.7695508599281311,
	-0.030552521347999573,
	0.4588877260684967,
	0.715364933013916,
	-0.003544924547895789,
	0.514762282371521,
	0.735663652420044,
	-0.03838041424751282,
	0.4565298855304718,
	0.6823055148124695,
	-0.001983386930078268,
	0.4433104991912842,
	0.6957772374153137,
	0.022011971101164818,
	0.5829482078552246,
	0.5056677460670471,
	-0.025178268551826477,
	0.5694928765296936,
	0.5032799243927002,
	-0.01878097839653492,
	0.5586386919021606,
	0.5013757348060608,
	-0.010522070340812206,
	0.5664116740226746,
	0.5546143054962158,
	-0.027349766343832016,
	0.5450059175491333,
	0.49781179428100586,
	0.008866756223142147,
	0.5509059429168701,
	0.4958842694759369,
	0.0019531159196048975,
	0.5483735203742981,
	0.4996299147605896,
	0.007014689035713673,
	0.5703294277191162,
	0.5603184700012207,
	-0.04979182407259941,
	0.5642762780189514,
	0.5007290244102478,
	-0.00458340160548687,
	0.5742692947387695,
	0.5004604458808899,
	-0.009643666446208954,
	0.5853822231292725,
	0.5001454949378967,
	-0.013449915684759617,
	0.5809279084205627,
	0.4644834101200104,
	0.0015282470267266035,
	0.5825574398040771,
	0.47810137271881104,
	-0.012397948652505875,
	0.5830555558204651,
	0.4860108494758606,
	-0.014821207150816917,
	0.5836350321769714,
	0.4925753176212311,
	-0.012557776644825935,
	0.5841907858848572,
	0.4969751834869385,
	-0.01094240602105856,
	0.562343418598175,
	0.4981342852115631,
	-0.003060895251110196,
	0.5608420968055725,
	0.4963582754135132,
	-0.004891609773039818,
	0.5584792494773865,
	0.49296125769615173,
	-0.006019322667270899,
	0.5563141107559204,
	0.48815980553627014,
	-0.003411252051591873,
	0.5411506295204163,
	0.5206871032714844,
	-0.010148998349905014,
	0.4267213046550751,
	0.5813583731651306,
	0.130332350730896,
	0.5556686520576477,
	0.49855491518974304,
	0.0026110748294740915,
	0.5537115335464478,
	0.4974842965602875,
	0.0016000381438061595,
	0.5790327787399292,
	0.5463152527809143,
	-0.02947448194026947,
	0.5572887659072876,
	0.5508096814155579,
	-0.017527181655168533,
	0.5767145156860352,
	0.5494547486305237,
	-0.03043963387608528,
	0.5368266105651855,
	0.6038581132888794,
	-0.013130576349794865,
	0.5153880715370178,
	0.5929628610610962,
	-0.009959367103874683,
	0.5491586327552795,
	0.5667904019355774,
	-0.02580786682665348,
	0.4673895239830017,
	0.7555429339408875,
	-0.00786743126809597,
	0.4818596839904785,
	0.7293239235877991,
	-0.022682422772049904,
	0.495491623878479,
	0.6994352340698242,
	-0.03373921662569046,
	0.5491659641265869,
	0.47655290365219116,
	0.006359810009598732,
	0.5558041334152222,
	0.6948980093002319,
	-0.047802869230508804,
	0.5476680397987366,
	0.7379486560821533,
	-0.04600735381245613,
	0.5386999845504761,
	0.7770034670829773,
	-0.041968364268541336,
	0.49371984601020813,
	0.6390219330787659,
	-0.0011353716254234314,
	0.45924699306488037,
	0.6230847239494324,
	0.017909176647663116,
	0.5497184991836548,
	0.6451905369758606,
	-0.004511586390435696,
	0.47387659549713135,
	0.6592671275138855,
	-0.0002052539784926921,
	0.559233546257019,
	0.6215396523475647,
	-0.023491984233260155,
	0.5614129304885864,
	0.5686260461807251,
	-0.05066792294383049,
	0.44358396530151367,
	0.6133047342300415,
	0.032851871103048325,
	0.4708636999130249,
	0.6121325492858887,
	0.008213784545660019,
	0.49006566405296326,
	0.6065746545791626,
	-0.0018736390629783273,
	0.5168517231941223,
	0.6100423336029053,
	-0.0064359731040894985,
	0.5354939103126526,
	0.6170545220375061,
	-0.008524289354681969,
	0.5488735437393188,
	0.6239800453186035,
	-0.01225472241640091,
	0.5771933197975159,
	0.6392103433609009,
	-0.03967931121587753,
	0.44793638586997986,
	0.5813608169555664,
	0.03372591733932495,
	0.4607813358306885,
	0.6608646512031555,
	0.004454560577869415,
	0.5899302363395691,
	0.5523223876953125,
	-0.06039418652653694,
	0.5526745915412903,
	0.5969607830047607,
	-0.02054455317556858,
	0.42069560289382935,
	0.6485627293586731,
	0.1089276522397995,
	0.5587642192840576,
	0.6315051317214966,
	-0.014726491644978523,
	0.5475225448608398,
	0.5667782425880432,
	-0.01196714024990797,
	0.48213472962379456,
	0.6519812345504761,
	0.00648120604455471,
	0.5598633885383606,
	0.5786183476448059,
	-0.04674546793103218,
	0.4334367513656616,
	0.5449712872505188,
	0.1299823373556137,
	0.5487878322601318,
	0.6506414413452148,
	-0.0019911546260118484,
	0.5709492564201355,
	0.5863202810287476,
	-0.06025518476963043,
	0.48470547795295715,
	0.46946802735328674,
	0.058563053607940674,
	0.4842768907546997,
	0.4550718665122986,
	0.08459614217281342,
	0.43073591589927673,
	0.5799112319946289,
	0.08159306645393372,
	0.4641961455345154,
	0.4890005588531494,
	0.07141872495412827,
	0.43456146121025085,
	0.6727609634399414,
	0.04671849310398102,
	0.546826958656311,
	0.4258698523044586,
	0.02725791372358799,
	0.590745210647583,
	0.5504941940307617,
	-0.04165741056203842,
	0.5412954092025757,
	0.586286187171936,
	-0.014774596318602562,
	0.4436746835708618,
	0.641162097454071,
	0.033192217350006104,
	0.5066189765930176,
	0.6455842852592468,
	-0.00486251525580883,
	0.5184691548347473,
	0.6446030139923096,
	-0.0072727142833173275,
	0.5479140281677246,
	0.49320465326309204,
	0.00425872253254056,
	0.45175716280937195,
	0.5515438318252563,
	0.04309084266424179,
	0.5716689825057983,
	0.4093017876148224,
	0.03537257760763168,
	0.5288559198379517,
	0.4254978597164154,
	0.05574021860957146,
	0.5085510611534119,
	0.43727684020996094,
	0.06812013685703278,
	0.5294480323791504,
	0.6459577679634094,
	-0.007264253217726946,
	0.5397399067878723,
	0.6484366655349731,
	-0.005095430184155703,
	0.5460420846939087,
	0.6496260166168213,
	-0.002480139257386327,
	0.448722779750824,
	0.664927065372467,
	0.016700154170393944,
	0.5367225408554077,
	0.6604592800140381,
	-0.008525077253580093,
	0.5248774290084839,
	0.6641359925270081,
	-0.011947032995522022,
	0.5131126642227173,
	0.6643978357315063,
	-0.01211329735815525,
	0.5015378594398499,
	0.6616957187652588,
	-0.009632859379053116,
	0.49454179406166077,
	0.6581682562828064,
	-0.005386826116591692,
	0.42287370562553406,
	0.6830542087554932,
	0.0815412774682045,
	0.49822375178337097,
	0.6477406620979309,
	-0.001520255347713828,
	0.5527865886688232,
	0.5294815897941589,
	-0.01714099943637848,
	0.5627815127372742,
	0.5586988925933838,
	-0.03600528463721275,
	0.5784335136413574,
	0.5339886546134949,
	-0.02759011648595333,
	0.5061179995536804,
	0.45171433687210083,
	0.049434877932071686,
	0.5258903503417969,
	0.4384379982948303,
	0.03929493948817253,
	0.5714614391326904,
	0.4175550043582916,
	0.017135778442025185,
	0.46368151903152466,
	0.4770064651966095,
	0.1051662415266037,
	0.544999361038208,
	0.654644787311554,
	-0.0049626752734184265,
	0.5698496103286743,
	0.6155015230178833,
	-0.040174294263124466,
	0.5492998361587524,
	0.4155541658401489,
	0.04280807077884674,
	0.43686404824256897,
	0.5469575524330139,
	0.0849812850356102,
	0.5724139213562012,
	0.497525155544281,
	-0.0076819309033453465,
	0.571051836013794,
	0.4942820966243744,
	-0.009672875516116619,
	0.5695209503173828,
	0.48912695050239563,
	-0.01125219278037548,
	0.568352222442627,
	0.48185718059539795,
	-0.008894178085029125,
	0.5634872913360596,
	0.46922165155410767,
	0.0019267196767032146,
	0.5532976388931274,
	0.49877411127090454,
	0.00014125469897408038,
	0.5498378276824951,
	0.49937909841537476,
	-0.0003464771434664726,
	0.5461046695709229,
	0.5010014176368713,
	-0.000992517452687025,
	0.5314297676086426,
	0.5094097256660461,
	-0.00024219641636591405,
	0.4727921783924103,
	0.5430164933204651,
	0.018606174737215042,
	0.5684020519256592,
	0.6312351822853088,
	-0.030571939423680305,
	0.5593469142913818,
	0.658668041229248,
	-0.011915151961147785,
	0.5505500435829163,
	0.6574605703353882,
	-0.007653950247913599,
	0.5557359457015991,
	0.5008780360221863,
	0.0018296822672709823,
	0.47189247608184814,
	0.5085380673408508,
	0.04370076581835747,
	0.5713229179382324,
	0.6579681634902954,
	-0.028726855292916298,
	0.5558371543884277,
	0.45455285906791687,
	0.010696874000132084,
	0.5793959498405457,
	0.6226080656051636,
	-0.05018666386604309,
	0.5619624853134155,
	0.592438817024231,
	-0.03683019056916237,
	0.5770038962364197,
	0.44832175970077515,
	0.005648030899465084,
	0.5234298706054688,
	0.4779168963432312,
	0.018901698291301727,
	0.5367434620857239,
	0.5548428893089294,
	-0.008794167079031467,
	0.5384476780891418,
	0.464290589094162,
	0.015589773654937744,
	0.5045143961906433,
	0.5556613802909851,
	-0.0058886404149234295,
	0.5249708890914917,
	0.5393781065940857,
	-0.005811261013150215,
	0.493373304605484,
	0.5317988991737366,
	0.007190273609012365,
	0.5732506513595581,
	0.4310152530670166,
	0.008203170262277126,
	0.5541122555732727,
	0.5849836468696594,
	-0.02628961205482483,
	0.5112152695655823,
	0.4670509099960327,
	0.03230071812868118,
	0.5303398966789246,
	0.45231160521507263,
	0.027262849733233452,
	0.5112295150756836,
	0.49444466829299927,
	0.017138518393039703,
	0.456536203622818,
	0.5265907049179077,
	0.05215836688876152,
	0.49230098724365234,
	0.4924716353416443,
	0.02936984971165657,
	0.4462452232837677,
	0.5166968703269958,
	0.08419863879680634,
	0.5152355432510376,
	0.519903302192688,
	0.0018940692534670234,
	0.561359703540802,
	0.606576681137085,
	-0.02975572645664215,
	0.5662010312080383,
	0.5621314644813538,
	-0.0529823824763298,
	0.5572969913482666,
	0.5595375299453735,
	-0.037801072001457214,
	0.5718374252319336,
	0.5709333419799805,
	-0.06340378522872925,
	0.5490903854370117,
	0.6679622530937195,
	-0.018672054633498192,
	0.527407169342041,
	0.6734738349914551,
	-0.02419179491698742,
	0.508400022983551,
	0.6744169592857361,
	-0.025058584287762642,
	0.49211499094963074,
	0.6726992130279541,
	-0.020663714036345482,
	0.48052042722702026,
	0.6679982542991638,
	-0.012749302200973034,
	0.4711986780166626,
	0.6476268768310547,
	0.011171777732670307,
	0.42707598209381104,
	0.6122310161590576,
	0.07379888743162155,
	0.48382824659347534,
	0.6278980374336243,
	0.0049666957929730415,
	0.49855461716651917,
	0.6234437227249146,
	-0.0017211008816957474,
	0.5171185731887817,
	0.624201238155365,
	-0.005750505719333887,
	0.5340672135353088,
	0.6283735036849976,
	-0.006624019704759121,
	0.5464488863945007,
	0.6333011984825134,
	-0.007337295450270176,
	0.5550276637077332,
	0.6379884481430054,
	-0.007992164231836796,
	0.4233008325099945,
	0.615493893623352,
	0.12387336790561676,
	0.5576412081718445,
	0.5564656257629395,
	-0.030713092535734177,
	0.5713993310928345,
	0.6012508869171143,
	-0.04824056476354599,
	0.5761169791221619,
	0.5607699751853943,
	-0.062473054975271225,
	0.5830904841423035,
	0.5550482273101807,
	-0.055564187467098236,
	0.5758211016654968,
	0.5593001246452332,
	-0.05566483736038208,
	0.56142657995224,
	0.5526345372200012,
	-0.025226224213838577,
	0.5857090950012207,
	0.5534002184867859,
	-0.05875344201922417,
	0.5865271091461182,
	0.551390528678894,
	-0.042232025414705276,
	0.5537580847740173,
	0.6491919159889221,
	-0.0035402625799179077,
	0.561633825302124,
	0.6454389095306396,
	-0.010467290878295898,
	0.56614089012146,
	0.6421998739242554,
	-0.01944989524781704,
	0.4902435541152954,
	0.6554324626922607,
	-0.0010803209152072668,
	0.4830193519592285,
	0.6585204005241394,
	-0.0019348353380337358,
];
